import * as pdfjsLib from 'pdfjs-dist';

// Set worker source - use local worker file via Vite's special import
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
 'pdfjs-dist/build/pdf.worker.min.mjs',
 import.meta.url
).toString();

export async function extractTextFromPDF(file: File): Promise<string> {
 try {
  console.log('[PDF Parser] Starting PDF text extraction for:', file.name);
  const arrayBuffer = await file.arrayBuffer();
  console.log(
   '[PDF Parser] File loaded, size:',
   arrayBuffer.byteLength,
   'bytes'
  );

  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  console.log('[PDF Parser] PDF loaded, pages:', pdf.numPages);

  let fullText = '';

  // Extract text from all pages
  for (let i = 1; i <= pdf.numPages; i++) {
   const page = await pdf.getPage(i);
   const textContent = await page.getTextContent();
   const pageText = textContent.items.map((item: any) => item.str).join(' ');
   fullText += pageText + '\n';
   console.log(
    `[PDF Parser] Extracted page ${i}/${pdf.numPages}, length: ${pageText.length}`
   );
  }

  const trimmedText = fullText.trim();
  console.log('[PDF Parser] Total extracted text length:', trimmedText.length);
  console.log('[PDF Parser] First 200 chars:', trimmedText.substring(0, 200));

  return trimmedText;
 } catch (error) {
  console.error('[PDF Parser] Error:', error);
  throw new Error('Failed to extract text from PDF');
 }
}
